"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_TYPE_NAMES = exports.SEARCH_TYPES = void 0;
var SEARCH_TYPE_NAMES = {
  PACKAGE: 'package',
  HOTEL: 'hotel',
  TRIP: 'trip'
};
exports.SEARCH_TYPE_NAMES = SEARCH_TYPE_NAMES;
var SEARCH_TYPES = [{
  name: SEARCH_TYPE_NAMES.PACKAGE,
  label: 'Туры'
}, {
  name: SEARCH_TYPE_NAMES.HOTEL,
  label: 'Отели',
  altLabel: 'Только отели'
}, {
  name: SEARCH_TYPE_NAMES.TRIP,
  label: 'Экскурсии'
}];
exports.SEARCH_TYPES = SEARCH_TYPES;